import { render, staticRenderFns } from "./CommentInput.vue?vue&type=template&id=aa94251e&scoped=true&"
import script from "./CommentInput.vue?vue&type=script&lang=js&"
export * from "./CommentInput.vue?vue&type=script&lang=js&"
import style0 from "./CommentInput.vue?vue&type=style&index=0&id=aa94251e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa94251e",
  null
  
)

export default component.exports